export default {"src":"/_next/static/media/like-red.613e3a3a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};